import React from 'react';
import { graphql } from 'gatsby';
import AccordionsBlock from './AccordionsBlock';
import CallToActionBlocks from '../components/CallToActionBlocks';
import ContactForm from './ContactForm';
import Content from './Content';
import Gallery from './Gallery';
import ImageContent from './ImageContent';
import Table from './Table';

const ModularBlocks = ({ items }) => {
  return items.map(item => (
    <React.Fragment key={item.id}>
      {item.model.apiKey === 'accordion_modular_block' && (
        <AccordionsBlock
          heading={item.instance.heading}
          accordions={item.instance.accordion}
        />
      )}
      {item.model.apiKey === 'call_to_action_blocks_modular_block' && (
        <CallToActionBlocks items={item.instance.callToActionBlocks} />
      )}
      {item.model.apiKey === 'contact_form_modular_block' && (
        <ContactForm
          heading={item.heading}
          headingBackgroundText={item.headingBackgroundText}
        />
      )}
      {item.model.apiKey === 'content_modular_block' && (
        <Content content={item.content} />
      )}
      {item.model.apiKey === 'gallery_modular_block' && (
        <Gallery
          heading={item.heading}
          headingBackgroundText={item.headingBackgroundText}
          images={item.images}
        />
      )}
      {item.model.apiKey === 'image_content_modular_block' && (
        <ImageContent
          heading={item.heading}
          content={item.content}
          image={item.image}
          flip={item.flip}
        />
      )}
      {item.model.apiKey === 'membership_form_modular_block' && (
        <ContactForm
          heading={item.heading}
          headingBackgroundText={item.headingBackgroundText}
          membership={true}
        />
      )}
      {item.model.apiKey === 'table_modular_block' && (
        <Table
          id={item.id}
          heading={item.heading}
          headingBackgroundText={item.headingBackgroundText}
          table={item.table}
        />
      )}
    </React.Fragment>
  ));
};

export default ModularBlocks;

export const ModularBlocksFragment = graphql`
  fragment ModularBlocksFragment on DatoCmsPage {
    modularBlocks {
      ... on DatoCmsAccordionModularBlock {
        model {
          apiKey
        }
        instance {
          heading
          accordion {
            id
            heading
            text
          }
        }
      }
      ... on DatoCmsCallToActionBlocksModularBlock {
        model {
          apiKey
        }
        instance {
          callToActionBlocks {
            id
            image {
              fluid(
                maxHeight: 400
                maxWidth: 600
                imgixParams: {
                  auto: "compress"
                  fit: "crop"
                  h: "400"
                  w: "600"
                }
              ) {
                ...GatsbyDatoCmsFluid
              }
              alt
            }
            text
            link {
              ... on DatoCmsHome {
                slug
              }
              ... on DatoCmsPage {
                slug
              }
              ... on DatoCmsCompetitionsArchive {
                slug
              }
              ... on DatoCmsCompetitionSingle {
                slug
              }
              ... on DatoCmsEventsArchive {
                slug
              }
              ... on DatoCmsEventSingle {
                slug
              }
              ... on DatoCmsNewsArchive {
                slug
              }
              ... on DatoCmsNewsSingle {
                slug
              }
            }
          }
        }
      }
      ... on DatoCmsContactFormModularBlock {
        id
        model {
          apiKey
        }
        heading
        headingBackgroundText
      }
      ... on DatoCmsContentModularBlock {
        id
        model {
          apiKey
        }
        content
      }
      ... on DatoCmsGalleryModularBlock {
        id
        model {
          apiKey
        }
        heading
        headingBackgroundText
        images {
          alt
          fixed(
            height: 580
            width: 940
            imgixParams: { auto: "compress", fit: "crop", h: "580", w: "940" }
          ) {
            ...GatsbyDatoCmsFixed
          }
          title
        }
      }
      ... on DatoCmsImageContentModularBlock {
        id
        model {
          apiKey
        }
        heading
        content
        image {
          fluid(
            maxHeight: 680
            maxWidth: 600
            imgixParams: { auto: "compress", fit: "crop", h: "680", w: "600" }
          ) {
            ...GatsbyDatoCmsFluid
          }
          alt
        }
        flip
      }
      ... on DatoCmsMembershipFormModularBlock {
        id
        model {
          apiKey
        }
        heading
        headingBackgroundText
      }
      ... on DatoCmsTableModularBlock {
        id
        model {
          apiKey
        }
        heading
        headingBackgroundText
        table
      }
    }
  }
`;
